import closeSvg from '../../svgs/close.svg?raw'
import { bindListingDetailCopyButtons } from '../lib/listing-detail-copy'

export class Dialog {
  $element: HTMLDialogElement
  $backdrop: HTMLDivElement
  $dialog: HTMLDivElement | null = null
  $loader: HTMLDivElement

  constructor() {
    this.$element = document.createElement('dialog')
    this.$element.classList.add('dialog')

    this.$backdrop = document.createElement('div')
    this.$backdrop.classList.add('dialog__backdrop')
    this.$element.appendChild(this.$backdrop)

    this.$loader = document.createElement('div')
    this.$loader.innerHTML = `
      <transition name="fade">
        <div class="center">
          <div class="loading-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </transition>`
    this.$backdrop.appendChild(this.$loader)

    document.body.appendChild(this.$element)

    this.$element.addEventListener('close', () => {
      // Clean up
      this.$element.remove()
      this.$dialog = null
    })
  }

  setVisible(visible: boolean) {
    if (visible) {
      this.$element.showModal()
    } else {
      this.$element.close()
    }
  }

  async setContentUrl(url: string, frameless: boolean = false) {
    this.$dialog?.remove()
    this.$backdrop.appendChild(this.$loader)

    let $content: Element | null = null
    try {
      const html = await fetch(url).then(response => response.text())
      const contentDocument = new DOMParser().parseFromString(html, 'text/html')
      $content = contentDocument.querySelector('.dialog-mount')
    } catch (error: unknown) {
      //
    }

    if ($content !== null) {
      this.setContent($content, frameless)
    } else {
      // TODO: Style message
      this.setContent('The content could not be loaded', false)
    }
  }

  setContent(content: Element | string, frameless: boolean = false) {
    const $previousDialog = this.$dialog
    this.$dialog = document.createElement('div')
    this.$dialog.classList.add('dialog__dialog')

    let $frame = this.$dialog

    if (!frameless) {
      $frame = document.createElement('div')
      $frame.innerHTML = `
        <button class="dialog__button-close dialog-close">
          <span class="sr-only">Close</span>
          ${closeSvg}
        </button>
      `
      $frame.classList.add('dialog__frame')
      this.$dialog.appendChild($frame)
    }

    if (typeof content === 'string') {
      $frame.innerHTML = content
    } else {
      $frame.appendChild(content)
    }

    $previousDialog?.remove()
    this.$loader.remove()
    this.$backdrop.appendChild(this.$dialog)

    const $close = this.$dialog.querySelector('.dialog-close')
    if ($close) {
      $close.addEventListener('click', () => {
        this.setVisible(false)
      })
    }

    this.$backdrop.addEventListener('click', (event: MouseEvent) => {
      if (event.target === this.$backdrop) {
        this.setVisible(false)
      }
    })

    bindListingDetailCopyButtons(this.$dialog)
  }
}
